import Swiper, { Scrollbar, Autoplay } from 'swiper';

export const productGridCarousel = () => {
  const sliders = document.querySelectorAll('.product-list-grid');

  sliders.forEach((slider) => {
    const autoplay = slider.dataset.autoplay === 'true';
    const autoplayDelay = parseInt(slider.dataset.autoplayDelay);

    const swiperOptions = {
      modules: [Scrollbar],
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        dragSize: 100,
      },
      speed: 400,
      spaceBetween: 20,
      slidesPerView: 6,
      breakpoints: {
        1200: {
          slidesPerView: 4.2,
          dragSize: 600,
        },
        900: {
          slidesPerView: 3.8,
          dragSize: 300,
        },
        600: {
          slidesPerView: 2.7,
          dragSize: 150,
        },
        320: {
          slidesPerView: 1.2,
          dragSize: 150,
        },
      },
    };

    if (autoplay) {
      swiperOptions.modules.push(Autoplay);
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
      };
    }

    new Swiper(slider, swiperOptions);
  });
};
